import { Routes, Route } from "react-router-dom";
import {
  EthereumClient,
  w3mConnectors,
  w3mProvider,
} from "@web3modal/ethereum";
import { Web3Modal } from "@web3modal/react";
import { configureChains, createConfig, WagmiConfig } from "wagmi";
import { bsc } from "wagmi/chains";
import HomeV1 from "./pages/homeV1";
import HomeV2 from "./pages/homeV2";
import HomeV3 from "./pages/homeV3";

const chains = [bsc];
const projectId = "f029677387f3e1590dcb9afe7d6772b0";

const { publicClient } = configureChains(chains, [w3mProvider({ projectId })]);
const wagmiConfig = createConfig({
  autoConnect: true,
  connectors: w3mConnectors({ projectId, version: 1, chains }),
  publicClient,
});
const ethereumClient = new EthereumClient(wagmiConfig, chains);

export const App = () => {
  return (
    <>
      <WagmiConfig config={wagmiConfig}>
        <Routes>
          <Route path="/" element={<HomeV1 variant="homev1" />} exact />
          <Route path="/home-two" element={<HomeV2 variant="homev2" />} exact />
          <Route
            path="/home-three"
            element={<HomeV3 variant="homev3" />}
            exact
          />
        </Routes>
      </WagmiConfig>
      <Web3Modal projectId={projectId} ethereumClient={ethereumClient} />
    </>
  );
}
